import { render, staticRenderFns } from "./EnterServicesReservation.vue?vue&type=template&id=31156430&scoped=true&"
import script from "./EnterServicesReservation.vue?vue&type=script&lang=js&"
export * from "./EnterServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31156430",
  null
  
)

export default component.exports